export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-postat.81cdf6e6.svg","height":40,"width":100,"blurWidth":0,"blurHeight":0};